import SmartFeedEngine from "SmartFeed/smart-feed-engine";
import { defineSmartFeedPiniaStore } from "@bloglovin/vue-framework";

export const useFanFollowerFollowingFeedStore = defineSmartFeedPiniaStore("fan-follower-following-feed-store", {
  state: () => ({
    visibility: 1,
    smartFeedEngine: new SmartFeedEngine(),
    orgIdBeingFollowed: null,
    metadata: {
      lastId: 0,
      hasMore: false,
      orgIdBeingFollowed: 0, // this will be fetched from another store
    },
  }),
  getters: {
    feedUrl() {
      let orgIdBeingFollowed = this.metadata.orgIdBeingFollowed;

      if (this.orgIdBeingFollowed) {
        orgIdBeingFollowed = this.orgIdBeingFollowed;
      }
      return `org/followers/${orgIdBeingFollowed}/smart-feed`;
    },
    smartFeedRequestGetParams() {
      return {
        last_id: this.metadata.lastId,
        visibility: this.visibility,
      };
    },
  },
});
